export const buildOpcaoPreenchida = (caracteristica_id, valor, unidade, id) => ({
	caracteristica_id,
	criado_em: null,
	id,
	unidade,
	validada: null,
	valor,
});
